module.exports = __webpack_public_path__ + "media/images/admin/icons/underline-0d7736c892eca6eafefef0013e8ae1dd.svg";